import {TimelineItem as MantineTimelineItem, TimelineItemProps as MantineTimelineItemProps} from "@mantine/core";

export type TimelineItemProps = MantineTimelineItemProps

export const TimelineItem = (props: TimelineItemProps) => {
    const {...rest} = props;
    return <MantineTimelineItem {...rest} />;
};
